import { useState } from 'react';
import { Title } from 'components/Title';

import QuickBooking from './QuickBooking'
export default function QuickbookingwidgetPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="QuickbookingwidgetPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="QuickBooking"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <QuickBooking/>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
